import { call, put, takeEvery, select } from 'redux-saga/effects';
import { getPropertySuccess } from '../actions/propertyActions';
import * as types from '../actions/actionType';
import { withApiErrorHandling } from '../helpers/sagaHelper';
import session from 'containers/App/session';
import { statsService } from 'utils/api';

export function* getRecommendationsForRange(action) {
    const token = yield select(session.selectors.selectUserToken);
    yield* withApiErrorHandling(function* fetchRecommendationsForRange() {
        const response = yield call(statsService({ token, propertyId: action.id }).getRecommendations, {
            start: action.startDate,
            end: action.endDate,
        });
        yield put(getPropertySuccess(types.GET_ALL_RECOMMENDATION_SUCCESS, response.data));
    });
}

export function* getOTAInsightsByRange(action) {
    const token = yield select(session.selectors.selectUserToken);
    yield* withApiErrorHandling(function* fetchOTAInsightsByRange() {
        const response = yield call(statsService({ token, propertyId: action.id }).getOTAInsightsByDay, {
            start: action.startDate,
            end: action.endDate,
        });
        yield put(getPropertySuccess(types.GET_OTA_INSIGHTS_BY_RANGE_SUCCESS, response.data));
    });
}

export function* getOTAInsightsExport(action) {
    const token = yield select(session.selectors.selectUserToken);
    yield* withApiErrorHandling(function* fetchOTAInsightsExport() {
        const response = yield call(statsService({ token, propertyId: action.id }).getOTAInsightsByDayExport, {
            start: action.startDate,
            end: action.endDate,
        });
        yield put(getPropertySuccess(types.GET_OTA_INSIGHTS_EXPORT_SUCCESS, response.data));
    });
}

export function* getEventsForRange(action) {
    const token = yield select(session.selectors.selectUserToken);
    yield* withApiErrorHandling(function* fetchEventsForRange() {
        const response = yield call(statsService({ token, propertyId: action.id }).getEventsBetweenDates, {
            start: action.startDate,
            end: action.endDate,
        });
        yield put(getPropertySuccess(types.GET_EVENTS_BY_RANGE_SUCCESS, response.data));
    });
}

export function* watchGetEventsForRange() {
    yield takeEvery(types.GET_EVENTS_BY_RANGE, getEventsForRange);
}

export function* watchGetRecommendationsForRange() {
    yield takeEvery(types.GET_RECOMMENDATIONS_FOR_RANGE, getRecommendationsForRange);
}
export function* watchGetOTAInsightsByRange() {
    yield takeEvery(types.GET_OTA_INSIGHTS_BY_RANGE, getOTAInsightsByRange);
}
